export const HousingOptions = {
    gilmore: "Gilmore",
    durfee: "Durfee",
    scott: "Scott",
    wyckoff: "Wyckoff",
    lichty: "Lichty",
    dykstra: "Dykstra",
    kollen: "Kollen",
    cook: "Cook",
    vanvleck: "Van Vleck",
    voorhees: "Voorhees",
    phelps: "Phelps",
    cottage: "Cottage",
    apartment: "Apartment",
    offcampus: "Off Campus"
}
